
import KoboDataTable from './KoboTable';
import { KoboSuiviTable } from './Visuel';


export const Betsileo = () => {

  return ( 
<>
 <KoboDataTable />
</>
     
      
 
  );
};
